function fadeInImages() {
  const lazyImageContainers = [].slice.call(document.querySelectorAll(".fade-in-image"));
  const lazyImages = [].slice.call(document.querySelectorAll(".fade-in-image img"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        const parent = entry.target.parentNode;
        if (entry.isIntersecting) {
          parent.classList.add("fade-in-image--loaded");
        } else {
          parent.classList.remove("fade-in-image--loaded");
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Fallback if IntersectionObserver is not supported
    lazyImageContainers.forEach(function(container) {
      container.classList.add("fade-in-image--loaded");
    });
  }
}

function watchForResize() {
  const siteHeaderElement = document.getElementById('site-header');
  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      if (entry.target.id === 'site-header') {
        setCssVariables();
      }
    }
  });

  if (siteHeaderElement) resizeObserver.observe(siteHeaderElement);
}

function loadAnimations() {
  const animationContainers = [].slice.call(document.querySelectorAll(".animate"));

  if ("IntersectionObserver" in window) {
    let animationObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate--loaded");
        } else {
          entry.target.classList.remove("animate--loaded");
        }
      });
    });

    animationContainers.forEach(function(container) {
      animationObserver.observe(container);
    });
  } else {
    // Fallback if IntersectionObserver is not supported
    animationContainers.forEach(function(container) {
      container.classList.add("animate--loaded");
    });
  }
}

function setCssVariables() {
  const root = document.documentElement;
  const siteHeaderElement = document.getElementById('site-header');
  const siteFooterElement = document.getElementById('site-footer');

  if (siteHeaderElement) {
    const headerHeight = siteHeaderElement.offsetHeight;
    root.style.setProperty('--site-header-height', headerHeight + "px");
  }

  if (siteFooterElement) {
    const footerHeight = siteFooterElement.offsetHeight;
    root.style.setProperty('--site-footer-height', footerHeight + "px");
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function handleNewsletterSignup() {
  const liveUrl = window.location.href;
  const signUpResult = liveUrl.includes('form_type=customer');
  if (!signUpResult) return;

  const newsletterForms = document.querySelectorAll('.js-newsletter-form');

  newsletterForms.forEach((form) => {
    const inputValue = form.querySelector('.js-newsletter-form-input').value.length;

    if (inputValue != 0) {
      const messageContainer = document.createElement('div');

      messageContainer.innerText = window.newsletterStrings.alreadySubscribed;
      messageContainer.classList.add('form-message', 'space--pt--xsmall', 'flex', 'flex--align-center');
      form.appendChild(messageContainer);
    }
  });
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.closest('details').hasAttribute('open')) {
      event.currentTarget.setAttribute('aria-expanded', 'false');
    } else {
      event.currentTarget.setAttribute('aria-expanded', 'true');
    }
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('js-hosted-video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".js-quantity-selector-button-minus");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".js-quantity-selector-button-plus");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class DrawerOpener extends HTMLElement {
  constructor() {
    super();

    this.drawerId = this.dataset.drawerId;
    this.drawerOpenButtons = document.querySelectorAll(`[data-drawer-to-open="${this.drawerId}"]`);
    this.drawerOpenButtons.forEach(button => button.addEventListener('click', this.onOpenButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  onOpenButtonClick(event) {
    const eventButton = event.currentTarget;
    const eventDrawerId = eventButton.dataset.drawerToToggle;

    event.preventDefault();
    this.openDrawer(eventDrawerId);
  }

  onCloseButtonClick(event) {
    const eventButton = event.currentTarget;
    const eventDrawerId = eventButton.dataset.drawerToToggle;

    event.preventDefault();
    this.closeDrawer(eventDrawerId);
  }

  openDrawer() {
    const targetDrawer = document.getElementById(this.drawerId);
    const drawerCloseButtons = document.querySelectorAll(`[data-drawer-to-close="${this.drawerId}"]`);

    if (!targetDrawer && this.drawerId === 'menu-drawer') {
      console.error(`The mobile menu is not found in the DOM. Make sure that the section within the "Header Group" is enabled in the theme editor.`);
    } else if (!targetDrawer) {
      console.error(`${this.drawerId} is not found in the DOM. Make sure that the section is enabled in the theme editor.`);
    }

    trapFocus(targetDrawer);
    this.onBodyClickEvent =
    this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    targetDrawer.removeAttribute('hidden');
    targetDrawer.setAttribute('open', true);
    setTimeout(() => {
      targetDrawer.classList.add('menu-opening');
      document.documentElement.classList.add('overlay-on');
      var openModals = document.querySelectorAll('[open].product-card__quick-add-modal')
      console.log(' el modal', openModals)
      if(openModals.length > 0){
        openModals.forEach((m) => {
          m.hide()
        })
      }
    });
    this.drawerOpenButtons.forEach(button => {
      button.setAttribute('aria-expanded', true);
      button.removeEventListener('click', this.onOpenButtonClick.bind(this));
    });
    drawerCloseButtons.forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  closeDrawer() {
    const targetDrawer = document.getElementById(this.drawerId);
    const drawerCloseButtons = document.querySelectorAll(`[data-drawer-to-close="${this.drawerId}"]`);

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.documentElement.classList.remove('overlay-on');
    removeTrapFocus();
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    targetDrawer.classList.remove('menu-opening');
    targetDrawer.addEventListener('transitionend', () => {
      targetDrawer.setAttribute('hidden', true);
    }, { once: true });
    drawerCloseButtons.forEach(button => button.removeEventListener('click', this.onCloseButtonClick.bind(this)));
    this.drawerOpenButtons.forEach(button => {
      button.addEventListener('click', this.onOpenButtonClick.bind(this));
      button.setAttribute('aria-expanded', false);
    });
  }

  onBodyClick(event) {
    if (event.target.classList.contains('page-layout__overlay')) this.closeDrawer();
  }

  closeSubmenu(dialogElement) {
    dialogElement.classList.remove('menu-opening');
    dialogElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(dialogElement);
  }
}

customElements.define('drawer-opener', DrawerOpener);

class SimpleModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute('open', '');
    this.removeAttribute('hidden');
  }

  hide() {
    this.removeAttribute('open');
    this.setAttribute('hidden', '');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('simple-modal-dialog', SimpleModalDialog);

if (!window.__whiskShowMoreDelegated) {
  window.__whiskShowMoreDelegated = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.show-more-link');
    if (!link) return;

    const parent = link.closest('.text-container');
    if (!parent) return;

    event.preventDefault();

    const truncatedText = parent.querySelector('.truncated-text');
    const fullText = parent.querySelector('.full-text');
    if (!truncatedText || !fullText) return;

    if (fullText.style.display === 'none') {
      fullText.style.display = 'block';
      truncatedText.style.display = 'none';
    } else {
      fullText.style.display = 'none';
      truncatedText.style.display = 'block';
    }
  });
}

class SimpleModalQuickView extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.loading = this.querySelector('.loading-field')
    this.wrapper = this.querySelector('.modal-wrapper')
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute('open', '');
    this.removeAttribute('hidden');
    if (!this.querySelector('.main-product')) {
      this.fetchProductData(this.dataset.url)
      .then(() => {
        this.loading.style.display = 'none'
        this.wrapper.style.display = 'flex'
      })
      .catch(error => {
        console.error('Failed to fetch product data:', error);
        this.loading.style.display = 'none'
      });
    } else {
      this.loading.style.display = 'none'
      this.wrapper.style.display = 'flex'
    }
  }

  async fetchProductData(qvUrl) {
    qvUrl += (qvUrl.indexOf('?')>0 ? '&' : '?') + 'view=ajax';

    try {
      const response = await fetch(qvUrl);
      const data = await response.text();
      let doc,
        productMainSection,
        popupContent;

      if (typeof data === "string") {
        const parser = new DOMParser();
        doc = parser.parseFromString(data, 'text/html');
      } else {
        doc = data;
      }

      const mainProduct = doc.querySelector('.main-product');
      if (!mainProduct) {
        throw new Error('Quick view: .main-product not found in AJAX response');
      }

      productMainSection = mainProduct.closest('.shopify-section');
      if (!productMainSection) {
        throw new Error('Quick view: shopify-section wrapper not found');
      }

      popupContent = this.querySelector('.modal-content');
      popupContent.replaceChildren();
      popupContent.appendChild(productMainSection);

      this.globalEval(popupContent);
      var reviewPlaceholder = this.querySelector('.review-placeholder');
      var reviewWrapper = this.querySelector('#reviews');

      if(reviewPlaceholder && reviewWrapper){
        reviewWrapper.innerHTML = reviewPlaceholder.innerHTML
      }

    } catch (error) {
      console.error('Error fetching the product data:', error);
      throw error;
    }
  }

  globalEval = function(textHtmlOrElement) {
    if (typeof(textHtmlOrElement)=="string") {
      var parser = new DOMParser();
      var doc = parser.parseFromString(textHtmlOrElement, 'text/html');
    } else {
      doc = textHtmlOrElement;
    }
    var scripts = doc.querySelectorAll('script');
    scripts.forEach(function(script) {
      if (script.src) {
        var d = document.createElement('script');
        d.src = script.src;
        for (var i = 0; i < script.attributes.length; i++) {
          var attrName = script.attributes[i].name;
          if (attrName !== 'src') {
            d.setAttribute(attrName, script.attributes[i].value);
          }
        }
        document.head.appendChild(d);
        return;
      }

      var scriptType = (script.type || '').toLowerCase();
      if (scriptType === 'module' || scriptType.includes('json')) {
        return;
      }

      var scriptBody = script.textContent.trim();
      if (!scriptBody) return;

      try {
        eval(scriptBody);
      } catch (evalError) {
        console.warn('Quick view: skipped inline script', evalError);
      }
    });
  }

  hide() {
    this.removeAttribute('open');
    this.setAttribute('hidden', '');
    this.loading.style.display = 'flex'
    this.wrapper.style.display = 'none'

    const popupContent = this.querySelector('.modal-content');
    if (popupContent) {
      popupContent.replaceChildren();
    }

    removeTrapFocus(this.openedBy);
  }
}
customElements.define('simple-modal-quickview', SimpleModalQuickView);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = document.getElementById(`Deferred-Poster-${this.dataset.mediaId}`);
    if (!poster) return;
    poster.addEventListener('click', () => this.loadContent());
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.loopMode = (this.dataset.loop || 'false').toLowerCase();
    this.enableSliderLooping = false;

    this.mqMobile = window.matchMedia('(max-width: 767px)');
    this.mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.applyLoopMode();

    this.initPages();

    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.loopMode === 'mobile' || this.loopMode === 'desktop') {
      this.mqMobile.addEventListener?.('change', () => {
        this.applyLoopMode();
        this.update();
      });
    }
  }

  applyLoopMode() {
    if (this.loopMode === 'true') {
      this.enableSliderLooping = true;
      return;
    }

    if (this.loopMode === 'mobile') {
      this.enableSliderLooping = this.mqMobile.matches;
      return;
    }

    if (this.loopMode === 'desktop') {
      this.enableSliderLooping = !this.mqMobile.matches;
      return;
    }

    this.enableSliderLooping = false;
  }

  initPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(el => el.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.slidesInView();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.sliderItemOffset) return;

    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.enableSliderLooping) {
      this.prevButton?.removeAttribute('disabled');
      this.nextButton?.removeAttribute('disabled');
      return;
    }

    const slideSpacingLeft = Number(this.dataset.slideSpacingLeft || 0);

    if (!this.prevButton) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft <= slideSpacingLeft) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  slidesInView() {
    let slidesInView = 0;

    this.sliderItemsToShow.forEach((element) => {
      if (this.isSlideVisible(element)) slidesInView++;
    });

    this.step = slidesInView || 1;
    return this.step;
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.sliderItemOffset || !this.step) return;

    const dir = event.currentTarget.name === 'next' ? 1 : -1;
    const delta = this.step * this.sliderItemOffset;

    const max = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
    let target = this.slider.scrollLeft + dir * delta;

    let wrap = false;

    if (this.enableSliderLooping) {
      if (target > max + 1) {
        target = 0;
        wrap = true;
      } else if (target < 0) {
        target = max;
        wrap = true;
      }
    }

    const behavior = (wrap || this.mqReduced.matches) ? 'auto' : 'smooth';

    this.slider.scrollTo({
      left: target,
      behavior
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.productFormId = this.dataset.productFormId;
    this.productId = this.dataset.productId;
    this.section = document.getElementById(`shopify-section-${this.sectionId}`);
    this.pdpQuickAdd = document.getElementById(`ProductQuickAdd-${this.sectionId}`);

    // Variable to target the main product section when the variant is changed outside of the main product form
    if (this.dataset.mainProductSectionId) {
      this.mainProductSectionId = this.dataset.mainProductSectionId;
    } else {
      this.mainProductSectionId = this.sectionId;
    }

    // Prevent auto scroll on radio button selection
    this.querySelectorAll('input[type="radio"]').forEach((radioButton) => {
      radioButton.addEventListener('change', event => {
        // To get the scroll position of current webpage
        const TopScroll = window.scrollY || document.documentElement.scrollTop;
        const LeftScroll = window.scrollX || document.documentElement.scrollLeft;

        // if scroll happens, set it to the previous value
        window.onscroll = function() {
          window.scrollTo(LeftScroll, TopScroll)
        };

        // renable scroll after 0.5 second
        setTimeout(() => {
          window.onscroll = function() {};
        }, 500);
      });
    });
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('fieldset :checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductCardMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.productCardContainer = this.closest('.product-card');
  }

  setActiveMedia(variantMediaId) {
    const variantMedia = this.querySelector(`[data-media-id="${variantMediaId}"]`);
    let selectedActiveMedia;
    if (variantMedia) {
      selectedActiveMedia = variantMedia;
    } else {
      selectedActiveMedia = this.querySelector(`[data-media-id="featured-image"]`);
    };

    this.querySelectorAll('[data-gallery-media-container]').forEach((media) => media.classList.remove('is-active'));

    selectedActiveMedia.classList.add('is-active');
  }
}

customElements.define('product-card-media-gallery', ProductCardMediaGallery);

class AnimatedDetails extends HTMLElement {
  constructor() {
    super();
    this.elementToggles = this.querySelectorAll('[data-animated-details-toggle]');
    this.elementTarget = this.querySelector('[data-animated-details-target]');
    this.elementParent = this.closest('[data-animated-details-parent]');

    this.elementToggles.forEach(toggle => toggle.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }));

    this.elementToggles.forEach(toggle => toggle.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    ));
  }

  open() {
    if (this.dataset.closeOtherAnimatedDetails === 'true') {
      document.querySelectorAll('animated-details[data-close-other-animated-details="true"]').forEach((element) => {
        element.close();
      });

      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    }

    this.onKeyupEvent =
      this.onKeyupEvent || this.onKeyup.bind(this);

    document.body.addEventListener('keyup', this.onKeyupEvent);

    this.classList.add('is-open');
    this.elementTarget.setAttribute('aria-hidden', false);
    this.elementToggles.forEach(toggle => toggle.setAttribute('aria-expanded', true));
  }

  close() {
    this.classList.remove('is-open');
    this.elementTarget.setAttribute('aria-hidden', true);
    this.elementToggles.forEach(toggle => toggle.setAttribute('aria-expanded', false));
    document.body.removeEventListener('keyup', this.onKeyupEvent);

    if (this.dataset.closeOtherAnimatedDetails === 'true') {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeyupEvent(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      document.querySelectorAll('animated-details').forEach((element) => {
        element.close();
      });
    };
  }
}
customElements.define('animated-details', AnimatedDetails);

class BlogSearch extends HTMLElement {
  constructor() {
    super();
    var self = this;
    this.searchInput = this.querySelector('#search-input');
    this.predictiveSearchResults = this.querySelector('#predictive-search-results');
    this.resultsPage = this.dataset.blogPage;

    this.urlParams = new URLSearchParams(window.location.search);
    this.searchTerm = this.urlParams.get('q');
    if (this.searchTerm) {
      this.searchInput.value = this.searchTerm;
      this.fetchSearchResults(this.searchTerm);
    }
    if (this.resultsPage) {
      this.searchInput.addEventListener('keypress', function(event) {
        if (event.key === 'Enter') {
          const query = self.searchInput.value;
          if(self.dataset.blogFilter) localStorage.setItem('blogFilter', self.dataset.blogFilter);
          window.location.href = `${self.resultsPage}?q=${encodeURIComponent(query)}`;
        }
      });
    }


    this.searchInput.addEventListener('input', function() {
      self.fetchSearchResults(self.searchInput.value)
    });
  }

  fetchSearchResults(query) {
    var self = this;
    if (query.length > 2) {
      fetch(`/search/suggest.json?q=${query}&resources[type]=article`)
        .then(response => response.json())
        .then(data => {
          console.log(data)
          self.predictiveSearchResults.innerHTML = '';
          var filter = self.dataset.blogFilter || localStorage.getItem('blogFilter') ? self.dataset.blogFilter || localStorage.getItem('blogFilter') : '/'
          var filteredArticles = data.resources.results.articles.filter(x => x.url.indexOf(filter)>-1)
          filteredArticles.forEach(article => {
            var articleElement = document.createElement('div');
            articleElement.classList.add('predictive-search-item');
            articleElement.innerHTML = `
              <a href="${article.url}" class="flex">
                <img src="${article.image ? article.image : 'default-image-url'}" alt="${article.title}">

                <span class="text-wrapper">
                  <span class="title">
                    ${article.title}
                    </span><br>
                    <span class="text">
                    ${article.body && article.body.length > 200 ? article.body.replace(/<[^>]*>/g, '').slice(0, 200) + '...' : ''}
                    </span>
                </span>
              </a>
            `;
            self.predictiveSearchResults.appendChild(articleElement);
          });
          if(!filteredArticles.length > 0) self.predictiveSearchResults.innerHTML = '<small>Your search did not match any results. Try a different search.</small>';
        })

    } else {
      self.predictiveSearchResults.innerHTML = '';
    }
  }
}

customElements.define('blog-search', BlogSearch);

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

// Swiper Functions
function initSwipers() {
  document.querySelectorAll('swiper-container').forEach((swiperContainer) => {
    // Media gallery is initialized separately in product-media-gallery.liquid
    const classesToExclude = ['js-product-media-gallery', 'js-product-media-gallery-thumbnails'];
    if (classesToExclude.some(className => swiperContainer.classList.contains(className))) return;
    swiperContainer.initialize();
    swiperContainer.classList.add('loaded');
    swiperContainer.parentElement.classList.add('swiper-loaded');
  });
}

function handleSwiperVideos() {
  document.querySelectorAll('.js-product-media-gallery').forEach((swiperContainer) => {
    const galleryContainer = document.getElementById(swiperContainer.dataset.galleryContainer);
    if (window.ProductMediaGallery && galleryContainer) {
      window.ProductMediaGallery.bindVideoAutoplay(galleryContainer);
    }
  });
}

function initMediaGallery() {
  document.querySelectorAll('.js-product-media-gallery').forEach((gallery) => {
    const sectionId = gallery.dataset.sectionId;
    const thumbnailsGallery = document.getElementById(`swiper-thumbnails--${sectionId}`);
    const galleryContainer = document.getElementById(gallery.dataset.galleryContainer);
    const thumbnailsGalleryPosition = gallery.dataset.thumbnailsGalleryPosition;

    // Thumbnails initialize before the main gallery; navigation is handled manually via data-media-id.
    let thumbnailsGallerySettings = {};
    if (thumbnailsGalleryPosition === "on-top") {
      thumbnailsGallerySettings = {
        centerInsufficientSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        freeMode: true,
        resizeObserver: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: `#swiper-thumbs-custom-button-next--${sectionId}`,
          prevEl: `#swiper-thumbs-custom-button-prev--${sectionId}`,
        },
        breakpoints: {
          1000: {
            direction: 'vertical',
            spaceBetween: 8,
          }
        },
      }
    } else if (thumbnailsGallery) {
      thumbnailsGallerySettings = {
        centerInsufficientSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        freeMode: true,
        resizeObserver: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: `#swiper-thumbs-custom-button-next--${sectionId}`,
          prevEl: `#swiper-thumbs-custom-button-prev--${sectionId}`,
        },
      }
    }

    if (thumbnailsGallery) {
      Object.assign(thumbnailsGallery, { ...thumbnailsGallerySettings });
      thumbnailsGallery.initialize();
      thumbnailsGallery.classList.add('loaded');
    }

    const hasGalleryFiltering = galleryContainer?.dataset.filterCriteria !== 'none';
    const galleryTransition = gallery.dataset.galleryTransition;
    const useSlideEffect = hasGalleryFiltering || galleryTransition !== 'fade';

    const slideshowSettings = {
      effect: useSlideEffect ? 'slide' : 'fade',
      slidesPerView: 1,
      loop: !hasGalleryFiltering,
      autoHeight: !hasGalleryFiltering,
      keyboardControlEnabled: true,
      noSwipingClass: 'swiper-slide--no-swiping',
      spaceBetween: 0,
      speed: 500,
      navigation: {
        nextEl: `#swiper-custom-button-next--${sectionId}`,
        prevEl: `#swiper-custom-button-prev--${sectionId}`,
      },
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
    };

    if (!useSlideEffect) {
      slideshowSettings.fadeEffect = {
        crossFade: true,
      };
    }

    Object.assign(gallery, { ...slideshowSettings });

    gallery.initialize();
    gallery.classList.add('loaded');
    galleryContainer.classList.add('swiper-loaded');

    if (window.ProductMediaGallery && galleryContainer) {
      window.ProductMediaGallery.initGallery(galleryContainer);
    }
  });
}

function initYotpoReviewJumpFallback() {
  if (!document.body.classList.contains('body--template-product')) return;

  const triggerSelector = '.yotpo-sr-bottom-line-summary.yotpo-sr-bottom-line-button';

  const findReviewsTarget = () => {
    return (
      document.querySelector('[id*="yotpo_product_reviews_reviews"]') ||
      document.querySelector('.yotpo-main-layout') ||
      Array.from(document.querySelectorAll('[data-yotpo-instance-id][data-yotpo-product-id]')).find((element) => {
        return !element.closest('.featured-product__info, .product-card, .product-card__quick-add-modal');
      })
    );
  };

  const scrollToReviews = () => {
    const target = findReviewsTarget();
    if (!target) return false;

    const headerOffset = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--site-header-height')
    ) || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth'
    });

    return true;
  };

  const attemptScrollToReviews = () => {
    let attempts = 0;
    const maxAttempts = 12;

    const run = () => {
      if (scrollToReviews() || attempts >= maxAttempts) return;
      attempts += 1;
      setTimeout(run, 150);
    };

    run();
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest(triggerSelector);
    if (!trigger || !trigger.closest('product-info')) return;
    attemptScrollToReviews();
  });
}
if(!window.inPLP){
  window.addEventListener("load", fadeInImages);
}
window.addEventListener("load", loadAnimations);
window.addEventListener("load", setCssVariables);
function scheduleInitMediaGallery() {
  if (!window.ProductMediaGallery) {
    window.addEventListener('load', initMediaGallery, { once: true });
    return;
  }
  initMediaGallery();
}

window.addEventListener("DOMContentLoaded", scheduleInitMediaGallery);
window.addEventListener("load", initSwipers);
window.addEventListener("load", handleSwiperVideos);
window.addEventListener("load", watchForResize);
window.addEventListener("load", handleNewsletterSignup);
window.addEventListener("load", initYotpoReviewJumpFallback);
